import React, { useEffect, useRef, useState } from "react";
import { connect } from 'react-redux';
import styles from './Plugins.module.scss'
import DraftHTML from "../../components/draftEditor/export/DraftHTML";
import Icon from "../../components/Icon";
import AspectRatioBox from "../../components/AspectRatioBox";
import Card, { CardItem } from "../../components/card/Card";
import Messages from "../../components/Messages";

function Plugin({feature, layoutDimensions}) {


    const [collapsed, setCollapsed] = useState(true);
    const [height, setHeight] = useState(undefined);
    const description = useRef();

    useEffect(() => {
        setHeight(description.current.offsetHeight)
    }, []);

    useEffect(() => {
        if (!collapsed) {
            setHeight(description.current.offsetHeight)
        }
    }, [layoutDimensions.height, layoutDimensions.width, collapsed]);

    const renderTitle = () => {

        const {name} = feature;
        const linkExplain = !!feature['links'] ? feature['links'].find(l => l['type'] === 'explain') : null;

        return (
            <div className={styles.featureHead}>
                <div className={styles.featureHead__title}>{name}</div>
                {
                    !!linkExplain &&
                    <Messages
                        className={styles.featureHead__link}
                        messages={[{
                            message: (
                                <a
                                    onClick={e => e.stopPropagation()}
                                    className={styles['feature-link__link']}
                                    href={linkExplain.url}
                                    rel={!linkExplain.follow ? 'nofollow' : undefined}
                                    target='_blank'
                                >
                                    {linkExplain.title ? linkExplain.title : 'Learn more about this app'}
                                </a>
                            ),
                            type: 'info',
                        }]}
                    />
                }
            </div>
        )
    }

    const renderDescription = () => {

        return (
            <div
                className={styles.description}
                onClick={e => {
                    e.stopPropagation();
                    if (!!collapsed) setCollapsed(false)
                }}
            >
                <div
                    className={styles.description__trigger}
                    onClick={!collapsed ? () => setCollapsed(true) : () => {}}
                >
                    <i className={`fas fa-chevron-down ${styles.description__trigger__icon}`} aria-hidden='true'/>
                </div>
                <div className={styles.description__container}>
                    <div
                        className={styles.description__container__content}
                        ref={description}
                    >
                        {
                            typeof feature.description !== 'string'
                                ?
                                <DraftHTML
                                    className={styles.featureDraft}
                                    content={feature.description}
                                    styles={{'unstyled': styles.featureDraft__unstyled}}
                                />
                                :
                                <div className={styles.description__container__content__string}>
                                    {feature.description}
                                </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <CardItem
            className={`${styles.feature}`}
            style={{'--contentHeight': !!collapsed ? '2.2rem' : height / 10 + 'rem'}}
        >
            <div
                className={styles.feature__content}
                data-feature-unfold={!collapsed}
            >
                <div className={styles.feature__content__icon}>
                    <AspectRatioBox ratio={[1, 1]}>
                        <Icon
                            className={styles.feature__content__icon__image}
                            icon={feature.icon}
                            alt={feature.name}
                            fallbackImages={['/images/no-app-icon.svg', '/images/no-app-icon-dark.svg']}
                            height={35}
                            width={35}
                            optimize
                        />
                    </AspectRatioBox>
                </div>
                <div className={styles.feature__content__main}>
                    {renderTitle()}
                    {renderDescription()}
                </div>
            </div>
        </CardItem>
    );
}

function Plugins({app, layoutDimensions}) {

    if (!app?.features?.length) return null;

    return (
        <Card className={styles.plugins}>
            <h3 className={styles.plugins__title}>Companion apps</h3>
            <Messages
                messages={[{type: 'info', block: 'plugins', message: 'Usually installed alongside'}]}
                padding='10px 20px 20px'
            />
            <div>
                {app.features.map((feature, index) => (
                    <Plugin feature={feature} layoutDimensions={layoutDimensions} key={index}/>
                ))}
            </div>
        </Card>
    )
}

const mapStateToProps = state => ({
    layoutDimensions: state.UI.layoutDimensions,
})

export default connect(mapStateToProps)(Plugins)